export default __webpack_public_path__ + "partner_279bcb6.png";